<template>
    <span class="ion-note">
        <slot></slot>
    </span>
</template>
<script>
    export default {
        name: 'ion-note'
    }
</script>


// WEBPACK FOOTER //
// note.vue?65ad56e3